export const APP_VERSION = '0.0.1'

export const IS_DEV = import.meta.env.DEV

export const API_URL = import.meta.env.VITE_API_URL

/**
 * Allow empty string to be treated as number
 */
export const STRING_AS_NUMBER = '' as any as number
